import { format, parse } from 'date-fns';

export const emptyLongDash = '—';

export const isValidDate = (dateObject) => {
  return dateObject instanceof Date && !isNaN(dateObject.valueOf());
};

export const getDate = (date) => {
  if (!date) {
    return emptyLongDash;
  }
  let parsedDate;
  if (date instanceof Date) {
    parsedDate = date;
  } else if (typeof date === 'string') {
    parsedDate = parse(date, 'yyyy-MM-dd', new Date());
  } else {
    // Preserve existing behavior for unsupported input types
    return emptyLongDash;
  }
  if (!isValidDate(parsedDate)) {
    return emptyLongDash;
  }

  try {
    return `${format(parsedDate, 'MM/dd/yyyy')}`;
  } catch (error) {
    return emptyLongDash;
  }
};

export const formatTimestamp = (timestamp) => {
  if (!timestamp) {
    return emptyLongDash;
  }
  const date = timestamp instanceof Date ? timestamp : new Date(timestamp);

  if (!isValidDate(date)) {
    return emptyLongDash;
  }

  try {
    const date = new Date(timestamp);
    // yields 2/8/2021 at 12:00 PM
    return `${getDate(date)} at ${format(date, 'h:mm aaa')}`;
  } catch (error) {
    return emptyLongDash;
  }
};

export const formatSplitTimestamp = (timestamp) => {
  if (!timestamp)
    return {
      day: emptyLongDash,
      time: emptyLongDash,
    };

  const date = new Date(timestamp);

  return {
    day: getDate(date),
    time: format(date, 'h:mm aaa'),
  };
};
